import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

import { WorkingHoursProps } from './WorkingHoursContainer';
import WorkingHoursDesktop from './WorkingHoursDesktop';
import WorkingHoursMobile from './WorkingHoursMobile';

const WorkingHours = (props: WorkingHoursProps) => {
  const isDesktop = useMediaQuery('(min-width:1280px)');

  return isDesktop ? <WorkingHoursDesktop {...props} /> : <WorkingHoursMobile {...props} />
};

export default WorkingHours;
